export default __webpack_public_path__ + "static/media/solutions.55b426b9.svg";